<template>
  <div>
    <div>
  <el-breadcrumb separator-class="el-icon-arrow-right">
  <el-breadcrumb-item :to="{ path: '/text' }">老师管理系统</el-breadcrumb-item>
  <el-breadcrumb-item>学生管理</el-breadcrumb-item>
  <el-breadcrumb-item>雅思模拟成绩</el-breadcrumb-item>
</el-breadcrumb>
    </div>
    <el-card>
      <el-row typeof="flex"  align="middle" justify="space-between">
    <el-col :span="2">
      <el-select v-model="Score" placeholder="分数查询" @keyup.enter.native="VileaDate">
      <el-option label="listening" value="listening"></el-option>
      <el-option label="reading" value="reading"></el-option>
      <el-option label="speaking" value="speaking"></el-option>
      <el-option label="writing" value="writing"></el-option>
      <el-option label="总分" value="overBandScore"></el-option>
      <el-option label="全部" value=""></el-option>
    </el-select></el-col>
  <el-col :span="1"><el-input v-model="Score1" @keyup.enter.native="VileaDate"></el-input></el-col>
  <el-col :span="1"><p class="lableforP" >~~</p></el-col>
  <el-col :span="1"><el-input v-model="Score2" @keyup.enter.native="VileaDate"></el-input></el-col>
  <el-col :span="2"><p class="lableforP" >考试时间：</p></el-col>
  <el-col :span="3"> 
    <el-select v-model="times" placeholder="所有时间" @keyup.enter.native="VileaDate">
      <el-option label="所有时间" value=""></el-option>
      <el-option :label="ielts" :value="ielts" v-for="(ielts,index) in datatime" :key="index"></el-option>
    </el-select>
  </el-col>
  <el-col :span="2"><p class="lableforP" >考试形式：</p></el-col>
  <el-col :span="3"> 
    <el-select v-model="examType" placeholder="全部形式" @keyup.enter.native="VileaDate">
      <el-option label="机考" value="机考"></el-option>
      <el-option label="纸考" value="纸考"></el-option>
      <el-option label="全部形式" value=""></el-option>
    </el-select>
  </el-col>
  <el-col :span="2"><el-button type="primary" @click="VileaDate">查询</el-button></el-col> 
   <el-col :span="3"> <p class="lableforSearch">查询到{{ieltsList.length}}条数据</p></el-col>
  
</el-row>
      <el-table
    ref="ieltsList"
    :data="ieltsList"
    border
    show-overflow-tooltip="true"
    tooltip-effect="dark"
    style="width: 100%">
    <el-table-column
      prop="studentID"
      :show-overflow-tooltip="true"
      label="学号"
      width="110">
    </el-table-column>
     <el-table-column
      prop="listening"
      :show-overflow-tooltip="true"
      label="listening"
      width="100">
    </el-table-column>

     <el-table-column
      prop="reading"
      label="reading"
      width="100">
    </el-table-column>
     <el-table-column
      prop="writing"
      label="writing"
      width="100">
    </el-table-column>
     <el-table-column
      prop="speaking"
      label="speaking"
      :show-overflow-tooltip="true"
      width="100">
    </el-table-column>
     <el-table-column
      prop="overBandScore"
      label="overBandScore"
      :show-overflow-tooltip="true"
      width="150">
    </el-table-column>
     <el-table-column
      prop="cefrlevel"
      label="CEFRlevel"
      width="100">
    </el-table-column>

    <el-table-column
      prop="examTime"
      label="考试时间"
      width="120">
    </el-table-column>
         <el-table-column
      prop="examAddress"
      label="考试地点"
      :show-overflow-tooltip="true"
      width="180">
    </el-table-column>
     <el-table-column
      prop="examType"
      label="考试形式"
      width="100">
    </el-table-column>
    <el-table-column
      prop="completionPTS"
      label="考试标题"
      width="100">
    </el-table-column>
  </el-table>

    </el-card>
  </div>
</template>

<script>
export default {
  data(){
    return {
        ieltsList:[],
        ieltsListText:[],
        Score:'',
        times:'',
        examType:'',
        datatime:[],
   Score1:'',
   Score2:'',
    }
  }, created(){
  this.getIelts()
},
  methods:{
    getIelts(){    
        let id=JSON.parse(localStorage.getItem('user')).studentID 
        this.axios.post("/ielts/getIeltsByIdText?studentId="+id)
        .then((resp) => {
          if (resp.data.status == 1) {
            console.log(resp.data.result)
            this.ieltsList=resp.data.result
            for(var i=0;i<this.ieltsList.length;i++){
        if(this.datatime.includes(this.ieltsList[i].examTime)){
        }else{
          this.datatime.push(this.ieltsList[i].examTime)
        }    
      }
          } else {
            alert("拿取数据失败");
          }
        })
        .catch((err) => {
          this.$message.error("出错");
        });
              
          

  },
  VileaDate(){
          if( this.ieltsListText.length==0){
            this.ieltsListText=this.ieltsList
          }
          if(this.Score1==''){this.Score1=0}
          if(this.Score2==''){this.Score2=100}
          this.ieltsList=this.ieltsListText.filter((item)=>{
            if(this.Score==''){
              return true
            }else if(this.Score=='listening'){
          return  this.Score1<= item.listening&item.listening <=this.Score2
        }else if(this.Score=='reading'){
          return  this.Score1<= item.reading&item.reading <=this.Score2
        }else if(this.Score=='speaking'){
          return  this.Score1<= item.speaking&item.speaking <=this.Score2
        }else if(this.Score=='writing'){
          return  this.Score1<= item.writing&item.writing <=this.Score2
        }else if(this.Score=='overBandScore'){
          return  this.Score1<= item.overBandScore&item.overBandScore <=this.Score2
        }
          })

          this.ieltsList=this.ieltsListText.filter((item)=>{
            if(this.Score==''){
              return true
            }else if(this.Score=='listening'){
          return  this.Score1<= item.listening&item.listening <=this.Score2
        }else if(this.Score=='reading'){
          return  this.Score1<= item.reading&item.reading <=this.Score2
        }else if(this.Score=='speaking'){
          return  this.Score1<= item.speaking&item.speaking <=this.Score2
        }else if(this.Score=='writing'){
          return  this.Score1<= item.writing&item.writing <=this.Score2
        }else if(this.Score=='overBandScore'){
          return  this.Score1<= item.overBandScore&item.overBandScore <=this.Score2
        }
          })
        this.ieltsList=this.ieltsList.filter((item)=>{
          if(this.times!=''){
            return this.times==item.examTime
          }else{
            return true
          }      
        })

        this.ieltsList=this.ieltsList.filter((item)=>{
          if(this.examType!=''){
            return this.examType==item.examType
          }else{
            return true
          }      
        })

        }
  }
}
</script>

<style scoped>
 .lableforSearch{
      margin-top:8px;
      color:grey
}

</style>


// WEBPACK FOOTER //
// src/components/work/student/IeltsStudentText.vue